import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, TablePagination } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Edit, PictureAsPdf } from '@material-ui/icons';
import CustomeSearch from '../../../components/CustomSearch';
import ActiveFilter from '../../../components/ActiveFilter';
import UploadPdfDialog from '../../../components/UploadPdfDialog';
import EditPdfDialog from '../../../components/EditPdfDialog';
import { fetchSafetyDocuments, addSafetyDocument, editSafetyDocument } from '../../../redux/actions/safety';
import { openAuthenticatedPdf } from '../../../services/safety';

const List = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [filterState, setFilterState] = useState({ isActive: '' });

  const dispatch = useDispatch();
  const { safetyDocuments } = useSelector(({ safety }) => safety);

  const getFilterObj = (values) => ({
    isActive: values.isActive === '' ? undefined : values.isActive
  });

  useEffect(() => {
    dispatch(fetchSafetyDocuments({ page: 1, pageSize: 100, ...getFilterObj(filterState) }));
  }, []);

  const columns = [
    { name: 'title', label: 'Title' },
    { name: 'originalName', label: 'File Name' },
    {
      name: 'isActive',
      label: 'Status',
      options: { customBodyRender: (value) => (value ? 'Active' : 'Inactive') }
    },
    {
      name: 'id',
      label: 'Actions',
      options: {
        customBodyRender: (value) => (
          <>
            <PictureAsPdf
              style={{ cursor: 'pointer' }}
              color="primary"
              onClick={() => openAuthenticatedPdf(`/safety/documents/${value}/file`)}
            />
            <Edit
              style={{ cursor: 'pointer' }}
              color="primary"
              onClick={() => {
                setSelectedDoc(safetyDocuments?.data.find((d) => d.id === value));
                setIsEditOpen(true);
              }}
            />
          </>
        )
      }
    }
  ];

  return (
    <Card className="userlist">
      <ActiveFilter
        onFilter={(values) => {
          setFilterState(values);
          dispatch(fetchSafetyDocuments({ page: 1, pageSize: 100, ...getFilterObj(values) }));
        }}
        initialFormState={filterState}
      />
      <CardContent>
        <div className="userlist__header">
          <Button color="primary" variant="contained" onClick={() => setIsUploadOpen(true)}>
            Upload Document
          </Button>
        </div>
        <MUIDataTable
          title="Safety Documents"
          data={safetyDocuments?.data || []}
          columns={columns}
          options={{
            filterType: 'textField',
            responsive: 'standard',
            selectableRows: 'none',
            pagination: false,
            elevation: 0,
            customSearchRender: (searchText, handleSearch, hideSearch) => (
              <CustomeSearch handleSearch={handleSearch} hideSearch={hideSearch} />
            ),
            customFooter: () => (
              <tbody>
                <tr>
                  <TablePagination
                    rowsPerPage={safetyDocuments?.pageSize || 100}
                    count={safetyDocuments?.count || 0}
                    page={safetyDocuments?.page ? safetyDocuments.page - 1 : 0}
                    onPageChange={(event, page) =>
                      dispatch(
                        fetchSafetyDocuments({
                          page: page + 1,
                          pageSize: safetyDocuments?.pageSize || 100,
                          ...getFilterObj(filterState)
                        })
                      )
                    }
                    onRowsPerPageChange={(event) =>
                      dispatch(
                        fetchSafetyDocuments({
                          page: 1,
                          pageSize: event.target.value,
                          ...getFilterObj(filterState)
                        })
                      )
                    }
                    rowsPerPageOptions={[10, 20, 40, 80, 100]}
                  />
                </tr>
              </tbody>
            ),
            print: false,
            viewColumns: false
          }}
        />
      </CardContent>

      {isUploadOpen && (
        <UploadPdfDialog
          open={isUploadOpen}
          title="Upload Safety Document"
          onUpload={addSafetyDocument}
          handleClose={() => setIsUploadOpen(false)}
          handleOk={() => {
            setIsUploadOpen(false);
            dispatch(fetchSafetyDocuments({ page: 1, pageSize: 100, ...getFilterObj(filterState) }));
          }}
        />
      )}
      {isEditOpen && selectedDoc && (
        <EditPdfDialog
          open={isEditOpen}
          item={selectedDoc}
          onUpdate={editSafetyDocument}
          handleClose={() => {
            setIsEditOpen(false);
            setSelectedDoc(null);
          }}
          handleOk={() => {
            setIsEditOpen(false);
            setSelectedDoc(null);
          }}
        />
      )}
    </Card>
  );
};

export default List;
